const HeaderOnscroll = (header, options = {}) => {
    opts = {
        scrolledClass: 'scrolled',
        scrollOffset: 32,
        ...options
    }
    if (document.body.scrollTop > opts.scrollOffset || document.documentElement.scrollTop > opts.scrollOffset) {
        header.classList.add(opts.scrolledClass);
    }
    window.addEventListener('scroll', () => {
        if (window.scrollY > opts.scrollOffset) {
            header.classList.add(opts.scrolledClass);
        } else {
            header.classList.remove(opts.scrolledClass);
        }
    })
}

export default HeaderOnscroll;